import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.5 20H18.501V8.66406L13.8369 4H5.5V20ZM20.4922 20.4219C20.4753 20.5927 20.4331 20.7607 20.3672 20.9199C20.2793 21.1321 20.1507 21.3249 19.9883 21.4873C19.8258 21.6497 19.6331 21.7792 19.4209 21.8672C19.2086 21.9551 18.9807 22 18.751 22H5.25C4.78587 22 4.34089 21.8155 4.0127 21.4873C3.68451 21.1591 3.5 20.7141 3.5 20.25V3.75C3.5 3.28587 3.68451 2.84088 4.0127 2.5127C4.34088 2.18451 4.78587 2 5.25 2H14.251L14.3496 2.00488C14.5785 2.02762 14.7939 2.12888 14.958 2.29297L20.208 7.54297C20.3955 7.73049 20.501 7.98484 20.501 8.25V20.25L20.4922 20.4219Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.875 3C12.875 2.44772 13.3227 2 13.875 2C14.4273 2 14.875 2.44772 14.875 3V7.625H19.501C20.0532 7.62513 20.501 8.07279 20.501 8.625C20.501 9.17721 20.0532 9.62488 19.501 9.625H13.875C13.3227 9.625 12.875 9.17729 12.875 8.625V3Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.3691 10.8496C11.7619 10.5293 12.3409 10.5519 12.707 10.918L15.332 13.543C15.7226 13.9335 15.7226 14.5665 15.332 14.957C14.9415 15.3476 14.3085 15.3476 13.918 14.957L12 13.0391L10.082 14.957C9.69151 15.3476 9.05849 15.3476 8.66797 14.957C8.27745 14.5665 8.27745 13.9335 8.66797 13.543L11.293 10.918L11.3691 10.8496Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11 17.25V11.625C11 11.0727 11.4477 10.625 12 10.625C12.5523 10.625 13 11.0727 13 11.625V17.25C13 17.8023 12.5523 18.25 12 18.25C11.4477 18.25 11 17.8023 11 17.25Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }